import React, { useEffect, useState } from "react";
import "./OrderTracking.css";
import { useNavigate } from "react-router-dom";
import { FaClipboardCheck, FaTruck, FaBoxOpen, FaGift } from "react-icons/fa";
import Loaderdots from "../../../components/LoaderDots/Loaderdots";
import NoData from "../../../components/NoData/NoData";
import ReviewModal from "../../ReviewModal/ReviewModal";
import InvoiceDownloadNew from "../InvoiceDownload/InvoiceDownloadNew";
import { MdOutlineRateReview, MdOutlineUpdate } from "react-icons/md";


const NewOrderTracking = () => {
  const [userOrders, setUserOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  console.log(17 , "selectedProductId")
  const navigate = useNavigate();

  const handleWriteReview = (productId) => {
    setSelectedProductId(productId);
    setModalOpen(true);
  };

  useEffect(() => {
    const fetchUserOrders = async () => {
      try {
        const response = await fetch("https://riymay.com/api/v1/user/orders", {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        });
        const data = await response.json();
        if (data.message === "Invalid token") {
          localStorage.removeItem("userToken");
          navigate("/login");
        }
        if (!response.ok) {
          throw new Error("Failed to fetch orders");
        }
        setUserOrders(data.userOrders);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUserOrders();
  }, [navigate]);

  if (loading)
    return (
      <div className="order-history-loading">
        <Loaderdots />
      </div>
    );
  if (error)
    return (
      <div className="order-history-error">
        <NoData />
      </div>
    );

  return (
    <>
      <div className="order-tracking-container">
        {userOrders && userOrders.length > 0 ? (
          <h2 className="trail-page-title">Review Your Orders</h2>
        ) : (
          <p className="nodata-label" style={{ padding: '40px 0' }}>No orders found</p>
        )}

        {userOrders && userOrders.length > 0 ? (
          userOrders.map((order) => {
            const expectedDeliveryDate = order?.orderShippingInfo?.expectedDeliveryDate
              ? new Date(order.orderShippingInfo.expectedDeliveryDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })
              : "Delivery Completed";

            const orderStages = [
              { key: "placed", icon: <FaClipboardCheck />, description: "Order has been placed." },
              { key: "confirmed", icon: <FaBoxOpen />, description: "Order has been confirmed." },
              { key: "out_for_delivery", icon: <FaTruck />, description: "Order is out for delivery." },
              { key: "completed", icon: <FaGift />, description: `Order has been delivered on.` }, 
              { key: "completed", icon: <MdOutlineUpdate size={30} />
                , description: ` Delivered Date ${expectedDeliveryDate}.` }, 
            ];

            const currentStatusIndex =
              orderStages.findIndex((stage) => stage.key === order.orderInfo.orderStatus) !== -1
                ? orderStages.findIndex((stage) => stage.key === order.orderInfo.orderStatus)
                : 0; // Fallback to "placed"

                return (
                  <div key={order.orderInfo._id} className="receipt">
                    <div className="receipt-header-container">
                    <div className="order-table">
                      <div className="table-header">
                        <span>Image</span>
                        <span>Title</span>
                        <span>Size</span>
                        <span>Quantity</span>
      
                        <span>Color</span>
                        <span>Price</span>
                        <span> Add Review</span>
                        {/* <span>Add Review</span> */}
                      </div>
                      <div className="table-body">
                        {order && order.orderItems ? (
                          order.orderItems.map((item) => (
                            <div>
                            <div key={item._id} className="table-row">


      
                              <img
                                src={`https://riymay.com/assets/${item.productUrl}`}
                                alt={item.productName}
                                className="product-imageoder"
                              />
                              <span className="product-title">
                                {item.productName.substring(0, 15)}
                                {item.productName.length > 15 ? "..." : ""}
                              </span>
                              <span>{item.size}</span>
                              <span>{item.quantity}</span>
                              <span>{item.color}</span>
       
                              <span className="price">₹ {item.unitPrice}</span>
                              <span  className="order-history-review"                          onClick={() => handleWriteReview(item.productId)}
                              >Add Review ...
</span>

                             
                             </div>
                              {/* <span className="price"> */}
                                
                                
                                 {/* <div className='order-history-review' > */}
                       
                        {/* <div
                         
                          className="order-history-review"
                          onClick={() => handleWriteReview(item.productId)}
                        >
                          <span>Write review...</span>
                        </div> */}
                  
                       
                      {/* </div> */}
                      {/* </span> */}
                             
                            </div>
                          ))
                        ) : (
                          <div>
                            <NoData />
                          </div>
                        )}
                      </div>
                    </div>
                    <h4>Track Your Status</h4>
      
                    <div className="stepper-container">
      
                      {orderStages.map((stage, index) => (
                        <div
                          key={stage.key}
                          className={`step ${
                            index <= currentStatusIndex ? "active" : ""
                          }`}
                        >
                        <p className="step-title">{stage.description}</p>
      
                          <div className="step-icon">
                            {stage.icon}
                            <span
                              key={stage.key}
                              className={`step ${
                                index <= currentStatusIndex ? "boder" : ""
                              }`}
                            ></span>
                            
                          </div>
                          
                          {/* <div className="step-info">
                            <p className="step-title">{stage.description}</p>
                          </div> */}
                        </div>
                      ))}
      
      

      
                    </div>
      
      
      
                    </div>
                  
      
                 
                  
      
                    <div className="order-details-container">
                      <h4>Order Details:</h4>
      
                      <div className="totals">
                        <p>
                          <strong>Invoice Number:</strong>{" "}
                          {order.orderInfo.razorpayOrderId}
                        </p>
      
                        <p>
                          Shipping Address:{" "}
                          <span>
                            {order.orderShippingInfo.orderShippingAddress.map(
                              (addr) => (
                                <span key={addr._id}>
                                  {addr.street}, {addr.city}, {addr.state} -{" "}
                                  {addr.pinCode}, {addr.country}
                                </span>
                              )
                            )}
                          </span>
                        </p>
                        <p>
                          Order Date:{" "}
                          <strong>
                            {new Date(order.orderInfo.orderPlacedDate).toDateString()}
                          </strong>
                        </p>
                        <p>
                          Total: <strong>₹ {order.orderInfo.totalOrderAmount}</strong>
                        </p>
                        <p>
                          Discount:{" "}
                          <strong>
                            ₹ {order.orderItems[0]?.discountAmount || 0}
                          </strong>
                        </p>
                        <p>
                          Delivery Charges:{" "}
                          <strong>
                            {order.orderShippingInfo.deliveryCharges === 0
                              ? "Free"
                              : `₹ ${order.orderShippingInfo.deliveryCharges}`}
                          </strong>
                        </p>
      
                        <div className="order-history-invoice-donload">
                       
      
                      <div className="order-history-invoice-dow">
                        
                        {/* <button>Download Invoice</button> */}
                        {/* <InvoiceDownloadButton invoiceId={order.orderInfo._id} /> */}
                        {/* <InvoiceDownload invoiceId={item._id}/> */}
      
                        <InvoiceDownloadNew invoiceId={order.orderInfo._id} /> 
                        
                        </div>
                        <div className="total-paid">
                          <h3>
                            Total Paid:{" "}
                            <span>
                              ₹
                              {order.orderInfo.totalOrderAmount -
                                (order.orderItems[0]?.discountAmount || 0)}
                            </span>
      
                           
      
      
                          </h3>
                        </div>
                        </div>
      
      
                       
                        
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <NoData /> )}
              
           
          </div>
          {modalOpen && (
            <ReviewModal
              productId={selectedProductId}
              onClose={() => setModalOpen(false)}
            />
          )}
          </>
        );
      };

export default NewOrderTracking;
